import { render, staticRenderFns } from "./lk-video.vue?vue&type=template&id=a43e4366&"
import script from "./lk-video.vue?vue&type=script&lang=js&"
export * from "./lk-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-video/lk-video.vue
// module id = 466
// module chunks = 0